  <div class="embedded-group" [formGroup]="internalFormGroup" *ngIf="internalFormGroup != null && (fieldsConfig?.accountingEntryNumberMode?.visible !== false || fieldsConfig?.generatePartialLettering?.visible !== false || fieldsConfig?.letteringScope?.visible !== false || fieldsConfig?.removeSpecialCharacters?.visible !== false)">
    <ng-container *ngIf="fieldsConfig?.accountingEntryNumberMode?.visible !== false">
        <label for="accountingEntryNumberMode"><h4><mat-icon>format_list_numbered</mat-icon>&nbsp;Numéro d'écriture comptable</h4></label>
        <mat-form-field class="full-width">
            <mat-label>Numéro d'écriture comptable</mat-label>
            <mat-select formControlName="accountingEntryNumberMode">
                <mat-option 
                    *ngFor="let mode of accountingNumberModeList"
                    [value]="mode.value">
                    {{mode.label}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </ng-container>

    <ng-container *ngIf="fieldsConfig?.generatePartialLettering?.visible !== false || fieldsConfig?.letteringScope?.visible !== false">
        <h4><mat-icon>account_tree</mat-icon>&nbsp;Lettrage</h4>
        <div class="lettering-block">
            <ng-container *ngIf="fieldsConfig?.letteringScope?.visible !== false">
                <mat-form-field class="full-width">
                    <mat-label>Options de lettrage</mat-label>
                    <mat-select formControlName="letteringScope">
                        <mat-option
                            *ngFor="let mode of letteringScopeList"
                            [value]="mode.value">
                            {{mode.label}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </ng-container>
            <ng-container *ngIf="fieldsConfig?.generatePartialLettering?.visible !== false">
                <mat-slide-toggle formControlName="generatePartialLettering">
                <div>
                    <span>Générer les lettrages partiels disponibles</span>
                </div>
                </mat-slide-toggle>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="fieldsConfig?.removeSpecialCharacters?.visible !== false && configMode !== 'STANDARD'">
        <mat-slide-toggle formControlName="removeSpecialCharacters">
            <div>
            <span>Supprimer les caractères spéciaux</span>
            </div>
        </mat-slide-toggle>
    </ng-container>
  </div>